module.exports = __webpack_public_path__ + "img/loginbackground.99b06d69.png";